import { storage } from "../util/firebase";
import { getDownloadURL, ref } from "firebase/storage";
import { Button } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";

function Preview({ path }) {
  async function handleClick(e) {
    e.preventDefault();
    const url = await getDownloadURL(ref(storage, path));
    window.open(url);
  }

  return (
    <>
      <Button
        leftIcon={<ExternalLinkIcon />}
        colorScheme="blue"
        size="xs"
        onClick={handleClick}
        rounded={4}
      >
        PDF
      </Button>
    </>
  );
}

export default Preview;
